import { render, staticRenderFns } from "./WorkingTime.vue?vue&type=template&id=19bd8c6a&"
import script from "./WorkingTime.vue?vue&type=script&lang=js&"
export * from "./WorkingTime.vue?vue&type=script&lang=js&"
import style0 from "./WorkingTime.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19bd8c6a')) {
      api.createRecord('19bd8c6a', component.options)
    } else {
      api.reload('19bd8c6a', component.options)
    }
    module.hot.accept("./WorkingTime.vue?vue&type=template&id=19bd8c6a&", function () {
      api.rerender('19bd8c6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/people/tabs/WorkingTime.vue"
export default component.exports